import e from"./HierarchicalMenu.vue_vue&type=script&lang.js";import{render as r}from"./HierarchicalMenu.vue_vue&type=template&id=4361a0b8&lang.js";e.render=r,e.__file="src/components/HierarchicalMenu.vue";export default e;
//# sourceMappingURL=HierarchicalMenu.vue.js.map
